<div class="dashobard-wrapper" *ngIf="i18n != undefined">
  <section class="heading">
    <h1>{{ i18n.dashboard.welcome }}</h1>
    <ul class="grid">
      <li>
        <p innerHtml="{{ i18n.dashboard.about_txt }}"></p>
      </li>
      <li>
        <div id="bg-shape-bottom">
          <img src="../../../assets/img/icons/029-music.svg" alt="" />
        </div>
      </li>
    </ul>
  </section>
  <hr />
  <h2>{{ i18n.dashboard.explore }}</h2>
  <section class="info-grid">
    <ul class="grid">
      <li routerLink="/mv-tilesets">
        <img src="../../../assets/img/dashboard/mv_tiles.png" alt="" />
        <p>{{ i18n.nav.mv_tiles }}</p>
      </li>
      <li routerLink="/engine-free">
        <img src="../../../assets/img/dashboard/trees.png" alt="" />
        <p>{{ i18n.nav.engine_free }}</p>
      </li>
      <li routerLink="/contact">
        <img src="../../../assets/img/dashboard/social_media.png" alt="" />
        <p>{{ i18n.nav.kontakt }}</p>
      </li>
      <li routerLink="/games/nachtschatten">
        <img src="../../../assets/img/dashboard/nachtschatten.png" alt="" />
        <p>{{ i18n.nav.nachtschatten }}</p>
      </li>
      <li routerLink="/games/bloxxs">
        <img src="../../../assets/img/dashboard/bloxxs.png" alt="" />
        <p>{{ i18n.nav.bloxxs }}</p>
      </li>
      <li routerLink="/games/hans-dampf-machine">
        <img src="../../../assets/img/dashboard/hans_dampf.png" alt="" />
        <p>{{ i18n.nav.hans_dampf }}</p>
      </li>
      <li routerLink="/games/cthulhu-clicker">
        <img src="../../../assets/img/dashboard/cthulhu.png" alt="" />
        <p>{{ i18n.nav.cthulhu }}</p>
      </li>
      <li routerLink="/games/halloween-im-hexenhaus">
        <img src="../../../assets/img/dashboard/halloween.png" alt="" />
        <p>{{ i18n.nav.halloween }}</p>
      </li>
      <li routerLink="/games/au-schwarte">
        <img src="../../../assets/img/dashboard/au_schwarte.png" alt="" />
        <p>{{ i18n.nav.au_schwarte }}</p>
      </li>
      <li routerLink="/apps/draw-it">
        <img src="../../../assets/img/dashboard/draw_it.png" alt="" />
        <p>{{ i18n.nav.draw_it }}</p>
      </li>
      <li routerLink="/apps/dreaming-fox">
        <img src="../../../assets/img/dashboard/dreaming_fox.png" alt="" />
        <p>{{ i18n.nav.dreaming_fox }}</p>
      </li>
    </ul>
  </section>
</div>
